.row {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-block-size: var(--control-height);
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text);
  font-size: var(--font-size-13);
  text-align: start;
  cursor: pointer;
}

.row:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
  border-radius: var(--radius-small);
}

.row:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.track {
  position: relative;
  flex: none;
  inline-size: 32px;
  block-size: 18px;
  border-radius: var(--radius-pill);
  background: var(--border-control);
  transition: background var(--motion-duration);
}

.track::after {
  content: "";
  position: absolute;
  inset-block-start: 2px;
  inset-inline-start: 2px;
  inline-size: 14px;
  block-size: 14px;
  border-radius: 50%;
  background: var(--text-inverse);
  box-shadow: var(--shadow-popover);
  transition: transform var(--motion-duration) var(--motion-ease);
}

.row[aria-checked="true"] .track {
  background: var(--control-checked);
}

.row[aria-checked="true"] .track::after {
  transform: translateX(14px);
}
